interface TfcHistoryNote {
  from: string;
  message: string;
}

export interface TfcHistoryEntry {
  id: string;
  actionLabel: string;
  totalCents: number;
  at: string;
  byName: string;
  byCompany: string;
  lineItems: TfcLineItem[];
  notes: TfcHistoryNote[];
}

function formatRoleName(role: TfcRole): string {
  return `${role.user.first_name} ${role.user.last_name}`;
}

function buildNote(
  role: TfcRole,
  message: string | null,
): TfcHistoryNote | null {
  if (!message) return null;
  return { from: `${formatRoleName(role)} (${role.company.name})`, message };
}

export function buildTfcHistoryEntries(
  revisions: TfcRevision[],
): TfcHistoryEntry[] {
  const ordered = [...revisions].sort((a, b) => a.version - b.version);
  const entries: TfcHistoryEntry[] = [];
  ordered.forEach((rev) => {
    const submissionNote = buildNote(rev.submitted_by, rev.notes);
    const submissionNotes: TfcHistoryNote[] = submissionNote
      ? [submissionNote]
      : [];
    entries.push({
      id: `rev-${rev.version}`,
      actionLabel:
        rev.version === 1 ? "Freight cost submitted" : "Freight cost revised",
      totalCents: rev.total_cents,
      at: rev.submitted_at,
      byName: formatRoleName(rev.submitted_by),
      byCompany: rev.submitted_by.company.name,
      lineItems: rev.line_items,
      notes: submissionNotes,
    });
    if (rev.action) {
      // Action entries include the submission note alongside the action note so the detail
      // dialog shows the full exchange (what was proposed + the reviewer's response).
      const actionNote = buildNote(rev.action.created_by, rev.action.notes);
      const actionNotes: TfcHistoryNote[] = [...submissionNotes];
      if (actionNote) actionNotes.push(actionNote);
      entries.push({
        id: `rev-${rev.version}-action`,
        actionLabel:
          rev.action.action === "APPROVED"
            ? "Freight cost confirmed"
            : "Changes requested",
        totalCents: rev.total_cents,
        at: rev.action.created_at,
        byName: formatRoleName(rev.action.created_by),
        byCompany: rev.action.created_by.company.name,
        lineItems: rev.line_items,
        notes: actionNotes,
      });
    }
  });
  return entries.reverse();
}
